function onCheckoutAbandoned(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onCheckoutAbandoned', e);
  }

  // Do something stub onCheckoutAbandoned

  return;
}

export default onCheckoutAbandoned;
